export const KEY_SYNC_REASONS = {
  MISSING_LOCAL_KEY: 'missing-local-key',
  BAD_LOCAL_KEY: 'bad-local-key',
  REMOTE_DEVICE_NEEDED: 'remote-device-needed',
  REMOTE_DEVICE_BAD_KEY: 'remote-device-bad-key',
  SYNC_TIMEOUT: 'sync-timeout',
  SYNC_REQUEST_FAILED: 'sync-request-failed',
};

export const KEY_SYNC_ERROR_MESSAGE = 'Error syncing. Try again with the other device open.';

export const getKeySyncReasonMessage = (reason) => {
  switch (reason) {
    case KEY_SYNC_REASONS.MISSING_LOCAL_KEY:
      return 'This device does not have the key for this conversation.';
    case KEY_SYNC_REASONS.BAD_LOCAL_KEY:
      return 'This device has a key, but it could not decrypt the latest messages.';
    case KEY_SYNC_REASONS.REMOTE_DEVICE_NEEDED:
      return 'Open Messenger on a device that can already read this conversation.';
    case KEY_SYNC_REASONS.REMOTE_DEVICE_BAD_KEY:
      return 'Another device sent a key, but this device still could not decrypt the conversation.';
    case KEY_SYNC_REASONS.SYNC_TIMEOUT:
      return 'No usable key arrived before the sync request timed out.';
    case KEY_SYNC_REASONS.SYNC_REQUEST_FAILED:
      return 'The key sync request failed. Check your connection and try again.';
    default:
      return 'This conversation encryption key is not synced on this device.';
  }
};

export const getKeySyncStatusLabel = (status, reason) => {
  if (status === 'requesting') return 'Requesting encryption key sync';
  if (status === 'waiting') return 'Waiting for encryption key sync';
  if (status === 'hydrating') return 'Syncing encryption keys';
  if (status === 'error') return KEY_SYNC_ERROR_MESSAGE;
  if (status === 'missing') return `Encryption keys not synced: ${getKeySyncReasonMessage(reason)}`;
  return 'Encryption keys synced';
};
